import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  updateStudent,
  deleteStudent,
  UPDATE_STUDENT_SUCCESS_MESSAGE,
  DELETE_STUDENT_SUCCESS_MESSAGE,
  IStudentParam,
  studentsPath,
  fetchStudent,
  fetchClasses,
  fetchPlans,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import Toast from "../../../molecules/Toast";
import StudentForm from "../../../templates/manager/StudentForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useDidMountEffect from "../../../hooks/useDidMountEffect";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export default (props: { match: { params: { id: string } } }) => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const id = parseInt(props.match.params.id, 10);
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (
      state.success_message === UPDATE_STUDENT_SUCCESS_MESSAGE ||
      state.success_message === DELETE_STUDENT_SUCCESS_MESSAGE
    ) {
      Toast.success(state.success_message);
      dispatch(clearSuccessMessage());
      history.push(studentsPath);
    }
  }, [history, dispatch, state.success_message]);

  const updateStudentFunc = React.useCallback(
    (userManager: IStudentParam) => {
      dispatch(peep(updateStudent(userManager)));
    },
    [dispatch, peep],
  );

  const deleteStudentFunc = React.useCallback(
    (id: number) => {
      dispatch(peep(deleteStudent(id)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
    dispatch(fetchStudent(id));
  }, [dispatch, id, currentYear]);

  useDidMountEffect(() => {
    if (state.error) {
      Toast.error(state.error);
    }
    return () => dispatch(clearErrorMessage());
  }, [dispatch, state.error]);

  React.useEffect(() => {
    dispatch(fetchPlans());
  }, [dispatch]);

  const student = React.useMemo(() => {
    return state.students.filter(t => t.id === id)[0];
  }, [id, state.students]);

  return (
    <div>
      <Breadcrumb
        links={[
          {
            title:
              state.manager.school?.use_case === "cram_school"
                ? titles.cramSchoolStudents
                : titles.students,
            to: studentsPath,
          },
        ]}
        currentTitle={titles.editStudent}
      />
      {student && (
        <StudentForm
          title={titles.editStudent}
          calling={calling}
          error={state.error}
          student={student}
          classes={state.classes}
          school={state.manager.school!}
          plans={state.plans}
          isNextYear={false}
          upsertStudent={updateStudentFunc}
          deleteStudent={deleteStudentFunc}
        />
      )}
    </div>
  );
};
